<div  *ngIf="isLoading" class="loading">
    <i class="pi pi-spin pi-spinner" style="font-size: 5rem; color:green"></i>
</div>
